// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import PlusSvg from '../icons/action/Plus';
var Plus = createSvgIcon({
    as: PlusSvg,
    ariaLabel: 'plus',
    category: 'action',
    displayName: 'Plus'
});
export default Plus;
